export default "__VITE_PUBLIC_ASSET__f443d7f9__"